import iconPencilSquare from '@/components/Icons/PencilSquare/PencilSquare.vue';
import iconChevronDown from '@/components/Icons/ChevronDown/ChevronDown.vue';
import iconSettings from '@/components/Icons/Settings/Setting.vue';
import iconUser from '@/components/Icons/User/User.vue';
import iconEnter from '@/components/Icons/Enter/Enter.vue';
import apiUrl from '@/config/api';
import { async } from 'q';

export default {
  name: 'Menu',

  props: {},

  components: {
    iconPencilSquare,
    iconChevronDown,
    iconSettings,
    iconUser,
    iconEnter
  },

  data: () => {
    return {
      file: '',
      menuSlider: false,
      profile: {
        name: 'Hola WeLoveCorner',
        type: 'Administrador'
      },
      modules: [{
        _id: 'Actual',
        name: 'Aplicaciones',
        icon: 'user',
        path: 'opencall',
        submodules: []
      }],
      modules_admin: [{
        _id: 'Actual',
        name: 'Edición No. ',
        icon: 'user',
        path: 'opencall_admin',
        submodules: []
      }]
    }
  },

  methods: {
    changeLogoClick() {
      document.getElementById('file_logo').click();
    },

    changeLogo() {
      this.file = this.$refs.file_logo.files[0];
      if (this.file.type.split('/')[0] !== 'image') {
        alert('Sube una imagen...');
        return;
      }

      let formData = new FormData();

      formData.append('file', this.file);
      formData.append('data', JSON.stringify({ _id: this.$session.get('_id') }));
      (async () => {
        var rawResponse = await fetch(apiUrl + 'change_logo', {
        // var rawResponse = await fetch('https://api.salonacme.com/manager/change_logo', {
        // var rawResponse = await fetch('https://localhost:4001/manager/change_logo', {
          method: 'POST',
          headers: { 
            'Accept': 'multipart/form-data',
            // 'Content-Type': 'multipart/form-data',
            // 'Accept': '*/*',
            // 'Access-Control-Allow-Origin': this.apiUrl,
            // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
            // 'Access-Control-Allow-Headers': 'origin,X-Requested-With,content-type,accept',
            // 'Access-Control-Allow-Credentials': 'true' 
          },
          body: formData
        });
        // delete rawResponse.headers['Content-Type'];

        if (rawResponse.status) {
          console.log(rawResponse);
          // location.reload(true);
        } else {
          alert(response.msg);
        }
      })();

      return;

      fetch(apiUrl + 'change_logo', {
        method: 'POST',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        body: formData
      })
      .then(async response => {
        response = await response.json();

        if (!response.status) {
          alert(response.msg);
        }
      })
      .catch(error => alert(error));
    },

    changeOpencalView(edition) {
      this.$root.opencall_view = true;

      if (typeof edition._id !== 'undefined') {
        this.$root.old_edition = edition._id;
        this.$session.set('old_edition', edition._id);
      }
    },

    logout() {
      this.$router.push('/');
      this.$session.clear();
      this.$session.destroy();
      this.$parent.$forceUpdate();

      location.reload(true);
    },

    getEditions() {
      (async () => {
        var rawResponse = await fetch(apiUrl + 'get_editions', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        });

        const content = await rawResponse.json();

        if (content.status) {
          await content.editions.pop();
          await content.editions.reverse();

          let past_editions = {
            name: 'Ediciones Anteriores',
            icon: 'history',
            submodules: []
          }

          content.editions.forEach(e => {
            past_editions.submodules.push({
              _id: e._id,
              name: e.name,
              path: 'opencall_oldEdition'
            });
          });

          this.modules_admin.push(past_editions);
          this.get_actual_edition();
        }
      })();
    },

    get_actual_edition(){
      ( async () => {
          await fetch(apiUrl + 'get_actual_edition', {
          method: 'POST',
          headers:{
              'Content-Type': 'application/json'
          }
          }).then( async response => {
              response = await response.json();

              // some error && actual_edition do not exist
              if(!response.status && response.actual_edition === null )
              {
              }else{
                let actual_edition = response.actual_edition.name;
                this.modules_admin[0].name += actual_edition;
              }

          })
          .catch(error => console.log("get_actual_edition" + error));
      })();
  },
  },

  mounted() {
    if (this.$session.get('type') == 'admin') {
      this.profile.type = 'Administrador';
      this.getEditions();
    }
    else {
      this.profile.type = 'Consejo';
    }

    this.profile.name = this.$session.get('name');
  }
}
